module.exports = __webpack_public_path__ + "static/linguamillDesktop-42b2eb85f8853980d602cd21bbd5c699.jpg";